import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import SmartReport from './views/smart-report';
import PatientDetailsInput from './views/patientDetails';
import VerifyLastName from './views/verification';
import './App.css';
import PdfGenerator from '../src/views/pdfGenerator';
import PdfGeneratorLocalTest from './views/pdfGeneratorLocal';

// Define your routes
const routes = [
  {
    path: '/',
    element: <PatientDetailsInput />,
  },
  {
    path : "/verify-lastname",
    element: <VerifyLastName />
  },
  {
    path: '/report',
    element: <SmartReport />,
  },
  {
    path: '/pdfGenrator',
    element: <PdfGenerator />,
  },
  {
    path: '/pdfGenratorLocal',
    element: <PdfGeneratorLocalTest />,
  },
  
];

const router = createBrowserRouter(routes, {
  future: {
     v7_relativeSplatPath: true,
     v7_startTransition: false,
  },
});

function App() {
  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
